import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IMeasurementUnitsStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<IMeasurementUnitsStatsResponse>,
  IPathBaseParam,
  object
>("stores.measurementUnits.stats");

export const stats = {
  ...getApis,
};
